import { ReactNode } from "react";
import { SpinnerIcon } from "../SpinnerIcon";
import "./style.css";

interface FullPageSpinnerProps {
    children: any;
    isLoading: boolean;
    message?: string | ReactNode;
}

export const FullPageSpinner = ({
    children,
    isLoading,
    message,
}: FullPageSpinnerProps) => {
    return (
        <>
            {isLoading && (
                <div className="c-FullPageSpinner">
                    <div className="c-FullPageSpinner-content">
                        <SpinnerIcon className="c-FullPageSpinner-spinner-icon" />{" "}
                        <p className="c-FullPageSpinner-message">{message}</p>
                    </div>
                </div>
            )}
            {children}
        </>
    );
};
